module.exports = __webpack_public_path__ + "img/ppt-addin-01.55cf24ea.png";